export const MODAL_DATA = 'modal_data';

export interface IConfirmModalLabels {
  icon?: string;
  header: string;
  subText: string;
  buttonText: string;
  buttonText2?: string;
  modalType?: string;
}